/**
 * Copyright IBM Corp. 2020, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Suspense, lazy } from 'react';
import PropTypes from '../../_virtual/index.js';

var _excluded = ["kind"];
var ErrorIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/ErrorIllustration.js');
});
var NoDataIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/NoDataIllustration.js');
});
var NoTagsIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/NoTagsIllustration.js');
});
var NotFoundIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/NotFoundIllustration.js');
});
var NotificationsIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/NotificationsIllustration.js');
});
var UnauthorizedIllustration = /*#__PURE__*/lazy(function () {
  return import('./assets/UnauthorizedIllustration.js');
});
var getIllustration = function getIllustration(kind) {
  switch (kind) {
    case 'error':
      return ErrorIllustration;
    case 'noData':
      return NoDataIllustration;
    case 'noTags':
      return NoTagsIllustration;
    case 'notifications':
      return NotificationsIllustration;
    case 'notFound':
      return NotFoundIllustration;
    case 'unauthorized':
      return UnauthorizedIllustration;
    default:
      return function () {
        return null;
      };
  }
};
var EmptyStateIllustration = function EmptyStateIllustration(_ref) {
  var kind = _ref.kind,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Illustration = getIllustration(kind);
  return /*#__PURE__*/React__default.createElement(Suspense, null, /*#__PURE__*/React__default.createElement(Illustration, _extends({
    "aria-hidden": "true"
  }, rest)));
};
EmptyStateIllustration.propTypes = {
  kind: PropTypes.string
};

export { EmptyStateIllustration as default };
